import { render, staticRenderFns } from "./ValuesMobile.vue?vue&type=template&id=75bf8294&scoped=true"
import script from "./ValuesMobile.vue?vue&type=script&lang=js"
export * from "./ValuesMobile.vue?vue&type=script&lang=js"
import style0 from "./ValuesMobile.vue?vue&type=style&index=0&id=75bf8294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bf8294",
  null
  
)

export default component.exports